import { InjectionToken } from '@angular/core';

/**
 * Display name shown in browser tab titles (e.g. "Client Portal").
 * Separate from AUDIT_SOURCE so audit logging and UI branding stay independent.
 */
export const PORTAL_DISPLAY_NAME = new InjectionToken<string>('PORTAL_DISPLAY_NAME');

/**
 * Formats a page label with the portal suffix: `{page} | {portalName}`.
 */
export function formatPortalTitle(pageTitle: string, portalName: string): string {
  const page = pageTitle.trim();
  if (!page) {
    return portalName;
  }
  return `${page} | ${portalName}`;
}
